import React, {
	Component
} from 'react';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupButton
} from 'reactstrap';
import Switch from 'react-toggle-switch';
import PropTypes from 'prop-types';
import {
	connect
} from 'react-redux';
import {
	bindActionCreators
} from 'redux';
import {
	withRouter
} from 'react-router-dom';
import {
	compose
} from 'recompose';
import IdleTimer from 'react-idle-timer';
import Moment from 'moment-timezone';

import * as departureScheduleActions from '../../actions/departureScheduleActions';

import TimezonePicker from 'react-timezone';

// Departure Schedules
import withDepartureSchedules from '../../components/withDepartureSchedules';

class Schedule extends Component {
	constructor(props) {
		super(props);

		this.state = {
			collapse: true,
			departureSchedule: this.props.departureSchedule,
			hasDepartureScheduleChanges: false,
		};

		this.enableDisableState = this.enableDisableState.bind(this);
		this.updateDepartureScheduleState = this.updateDepartureScheduleState.bind(this);
		this.saveDepartureScheduleEvent = this.saveDepartureScheduleEvent.bind(this);
		this.saveDepartureSchedule = this.saveDepartureSchedule.bind(this);
		this.deleteDepartureSchedule = this.deleteDepartureSchedule.bind(this);
		this.toggle = this.toggle.bind(this);
	}

	componentWillMount() {
		if (!this.props.departureSchedule || !this.props.departureSchedule.id || this.props.departureSchedule.id === '') {
			this.props.history.push('/schedule');
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			departureSchedule: nextProps.departureSchedule
		});
	}

	enableDisableState(event) {
		this.refs.saveDepartureScheduleTimer.reset();

		const departureSchedule = this.state.departureSchedule;
		departureSchedule.enabled = !departureSchedule.enabled;
		
		var button = document.getElementById('saveDepartureSchedule');
		button.removeAttribute('disabled');
		button.classList.remove('disabled');
		button.onclick = this.saveDepartureSchedule;

		return this.setState({departureSchedule: departureSchedule, hasDepartureScheduleChanges: true});
	}

	updateDepartureScheduleState(event) {
		this.refs.saveDepartureScheduleTimer.reset();

		const departureSchedule = this.state.departureSchedule;
		
		const field = event.target.name;
		if (field === 'enabled') {
			departureSchedule.enabled = true;
		} else if (field === 'disabled') {
			departureSchedule.enabled = false;
		} else if (field === 'vehicleId') {
			departureSchedule.vehicleId = event.target.value;
		} else if (field === 'timezone') {
			departureSchedule.timezone = event.target.value;
		} else if (field === 'temperatureInC') {
			departureSchedule.temperatureInC = event.target.value;
		}
		
		var recurringDaysOfWeek = [];
		
		var sundayElement = document.getElementById('recurringDayOfWeekSunday');
		if (sundayElement.checked) {
			recurringDaysOfWeek.push('sunday');
		}
		
		var mondayElement = document.getElementById('recurringDayOfWeekMonday');
		if (mondayElement.checked) {
			recurringDaysOfWeek.push('monday');
		}
		
		var tuesdayElement = document.getElementById('recurringDayOfWeekTuesday');
		if (tuesdayElement.checked) {
			recurringDaysOfWeek.push('tuesday');
		}
		
		var wednesdayElement = document.getElementById('recurringDayOfWeekWednesday');
		if (wednesdayElement.checked) {
			recurringDaysOfWeek.push('wednesday');
		}
		
		var thursdayElement = document.getElementById('recurringDayOfWeekThursday');
		if (thursdayElement.checked) {
			recurringDaysOfWeek.push('thursday');
		}
		
		var fridayElement = document.getElementById('recurringDayOfWeekFriday');
		if (fridayElement.checked) {
			recurringDaysOfWeek.push('friday');
		}
		
		var saturdayElement = document.getElementById('recurringDayOfWeekSaturday');
		if (saturdayElement.checked) {
			recurringDaysOfWeek.push('saturday');
		}
		
		departureSchedule.recurringDaysOfWeek = recurringDaysOfWeek;

		if (recurringDaysOfWeek.length > 0) {
			departureSchedule.type = 'recurring';
		} else {
			departureSchedule.type = 'once';
		}
				
		var now = Moment();
		
		var hourElement = document.getElementById('hour');
		var hour = hourElement.value;

		var minuteElement = document.getElementById('minute');
		var minute = minuteElement.value;
		
		var ampmElement = document.getElementById('ampm');
		var ampm = ampmElement.value;

		if (departureSchedule.type === 'once') {
			if (hour !== null && hour !== '' && minute !== null && minute !== '' && ampm !== null && ampm !== '') {
				var dateStr = Moment().tz(departureSchedule.timezone).format('YYYY-MM-DD');
				var timezoneStr = Moment().tz(departureSchedule.timezone).format('z');
				var onceTimeStr = dateStr + ' ' + hour + ':' + minute + ' ' + ampm + ' ' + timezoneStr;
				var onceTime = Moment(onceTimeStr, 'YYYY-MM-DD h:mm A Z');
				if (onceTime.isBefore(now)) {
					onceTime.add(1, 'day');
				}
				departureSchedule.onceTime = onceTime.format();
				
				departureSchedule.recurringHour = null;
				departureSchedule.recurringMinute = null;
			}
		} else if (departureSchedule.type === 'recurring') {
			if (ampm === 'PM') {
				if (hour < 12) {
					departureSchedule.recurringHour = Number.parseInt(hour) + 12;
				} else {
					departureSchedule.recurringHour = hour;
				}
			} else {
				if (hour < 12) {
					departureSchedule.recurringHour = hour;
				} else {
					departureSchedule.recurringHour = Number.parseInt(hour) - 12;
				}
			}

			departureSchedule.recurringMinute = minute;
			
			departureSchedule.onceTime = null;
		}
		
		var button = document.getElementById('saveDepartureSchedule');
		button.removeAttribute('disabled');
		button.classList.remove('disabled');
		button.onclick = this.saveDepartureSchedule;

		return this.setState({departureSchedule: departureSchedule, hasDepartureScheduleChanges: true});
	}

	saveDepartureScheduleEvent(event) {
		event.preventDefault();
		
		this.saveDepartureSchedule();
	}
	
	saveDepartureSchedule() {
		var vehicleId = this.state.departureSchedule.vehicleId;
		if (vehicleId === null || vehicleId === '') {
			alert('Please select a vehicle.');
			return;
		}
		
		var timezone = this.state.departureSchedule.timezone;
		if (timezone === null || timezone === '') {
			alert('Please select a timezone.');
			return;
		}
		
		if (this.state.departureSchedule.type === 'once') {
			var onceTime = this.state.departureSchedule.onceTime;
			if (onceTime === null || onceTime === '') {
				alert('Please select a departure time.');
				return;
			}
		} else if (this.state.departureSchedule.type === 'recurring') {
			var recurringHour = this.state.departureSchedule.recurringHour;
			var recurringMinute = this.state.departureSchedule.recurringMinute;
			if (recurringHour === null || recurringHour === '' || recurringMinute === null || recurringMinute === '') {
				alert('Please select a recurring departure time.');
				return;
			}
		}
		
		var temperatureInC = this.state.departureSchedule.temperatureInC;
		if (temperatureInC === null || temperatureInC === '') {
			alert('Please select a temperature.');
			return;
		}
		
		if (this.state.hasDepartureScheduleChanges) {
			this.props.actions.updateDepartureSchedule('deviceId', this.context.authToken, this.state.departureSchedule).then((departureSchedule) => {
				if (departureSchedule.id) {
					var button = document.getElementById('saveDepartureSchedule');
					button.disabled = true;
					button.classList.add('disabled');
					button.onclick = undefined;

					this.props.actions.loadDepartureSchedules('deviceId', this.context.authToken);
					this.props.history.push('/schedule/view/' + departureSchedule.id);
				} else {
					alert("Could not save departure schedule");
				}
				
				this.setState({
					hasDepartureScheduleChanges: false
				});
			});
		}
	}

	deleteDepartureSchedule(event) {
		if (window.confirm("Delete this schedule?")) {
			this.props.actions.deleteDepartureSchedule('deviceId', this.context.authToken, this.props.departureSchedule).then((departureSchedule) => {
				if (departureSchedule.id) {
					this.props.history.push('/schedule');
				} else {
					alert("Could not delete schedule");
				}
			});
		}
	}

	toggle() {
		this.setState({
			collapse: !this.state.collapse
		});
	}
	
    render() {
  	  var isSubscriptionActive = false;
  	  if (this.context.subscriptions && this.context.subscriptions.status
  		  && (this.context.subscriptions.status === 'active' || this.context.subscriptions.status === 'canceled')) {
  		  isSubscriptionActive = true;
  	  }
	  
	  var hour;
	  var minute
	  var ampm;
	  
	  if (this.state.departureSchedule.type === 'once') {
		  var onceTimeMoment = Moment(this.state.departureSchedule.onceTime);
		  
		  hour = onceTimeMoment.hour();
		  minute = onceTimeMoment.minute();
	  } else if (this.state.departureSchedule.type === 'recurring') {
		  hour = this.state.departureSchedule.recurringHour;
		  minute = this.state.departureSchedule.recurringMinute;
	  }
	  
	  if (hour < 12) {
		  ampm = 'AM';
	  } else {
		  ampm = 'PM';
	  }

	  if (hour == 0) {
		  hour += 12;
	  } else if (hour > 12) {
		  hour -= 12;
	  }
	  
	  var minuteStr = '' + minute;
	  var minute = minuteStr.padStart(2, '0');

  	  var temperatureUnit = this.context.preferences.temperatureUnit;
  	  if (temperatureUnit == null) {
  		  temperatureUnit = "fahrenheit"
  	  }

  	  var temperatureInC;
  	  if (this.state.departureSchedule.temperatureInC != null) {
      	  temperatureInC = Number.parseFloat(this.state.departureSchedule.temperatureInC);
  	  }

  	  if (temperatureInC != null) {
  		  if (temperatureUnit == "fahrenheit") {
  		      // Round to nearest fahrenheit degree
  		      var temperatureInF = Math.round((temperatureInC * 9.0 / 5.0) + 32.0);
  		      temperatureInC = ((temperatureInF - 32.0) * 5.0 / 9.0).toFixed(1);
  	      } else if (temperatureUnit == "celsius") {
  		      // Round to nearest celsius half-degree
  		      temperatureInC = (Math.round(temperatureInC * 2.0) / 2.0).toFixed(1);
  	      }
	  }

      return (
        <div className="animated fadeIn">
          <Row>
            <Col xs="12" sm="6">
			  <IdleTimer ref="saveDepartureScheduleTimer" timeout={1500} startOnLoad={false} idleAction={this.saveDepartureSchedule}>
              <Card>
                <CardHeader>
                  <strong>Schedule</strong>
                </CardHeader>
                <CardBody>
				      <Row>
				        <Col xs="12">
			  				Off <Switch id="enableDisable" name="enableDisable" onClick={this.enableDisableState} on={this.state.departureSchedule.enabled}/> On
		  					<br/><br/>
					    </Col>
					  </Row>
                  <Row>
                    <Col xs="12">
                      <FormGroup>
                        <Label htmlFor="vehicleId">Vehicle</Label>
                        <Input type="select" name="vehicleId" id="vehicleId" value={this.state.departureSchedule.vehicleId} onChange={this.updateDepartureScheduleState}>
  					  {this.context.teslaVehicles.map(vehicle => {
  						  return (
                          <option value={vehicle.vehicleId} key={vehicle.vehicleId}>{vehicle.displayName}</option>
  						  );
  					  })}
                        </Input>
					    <MessageNoVehicles show={this.context.teslaVehicles.length === 0}/>
                      </FormGroup>
  				  </Col>
  				</Row>
  				<Row>
  				  <Col xs="4">
                      <FormGroup>
                        <Label htmlFor="hour">Hour</Label>
                        <Input type="select" name="hour" id="hour" value={hour} onChange={this.updateDepartureScheduleState}>
                          <option value="12">12</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                        </Input>
                      </FormGroup>
  				  </Col>
  				  <Col xs="4">
                      <FormGroup>
                        <Label htmlFor="minute">Minute</Label>
                        <Input type="select" name="minute" id="minute" value={minute} onChange={this.updateDepartureScheduleState}>
                          <option>00</option>
                          <option>05</option>
                          <option>10</option>
                          <option>15</option>
                          <option>20</option>
                          <option>25</option>
                          <option>30</option>
                          <option>35</option>
                          <option>40</option>
                          <option>45</option>
                          <option>50</option>
                          <option>55</option>
                        </Input>
                      </FormGroup>
  				  </Col>
  				  <Col xs="4">
                      <FormGroup>
                        <Label htmlFor="ampm">AM/PM</Label>
                        <Input type="select" name="ampm" id="ampm" value={ampm} onChange={this.updateDepartureScheduleState}>
                          <option>AM</option>
                          <option>PM</option>
                        </Input>
                      </FormGroup>
  				  </Col>
  				</Row>
                  <Row>
                    <Col xs="12">
                      <FormGroup>
                        <Label htmlFor="timezone">Timezone</Label>
  					  <TimezonePicker
  						value={this.state.departureSchedule.timezone}
  					    onChange={this.updateDepartureSchedule}
  					    inputProps={{
  					      placeholder: 'Select Timezone...',
  					      name: 'timezone',
  						  id: 'timezone',
  					    }}
  					  />
                      </FormGroup>
  				  </Col>
  				</Row>
  				<Row>
                    <Col xs="12">
                      <FormGroup check className="checkbox">
                        <Input className="form-check-input" type="checkbox" id="recurringDayOfWeekSunday" name="recurringDayOfWeek" value="sunday" defaultChecked={this.state.departureSchedule.recurringDaysOfWeek && this.state.departureSchedule.recurringDaysOfWeek.includes('sunday')} onChange={this.updateDepartureScheduleState}/>
                        <Label check className="form-check-label" htmlFor="recurringDayOfWeekSunday">Sunday</Label>
                      </FormGroup>
                      <FormGroup check className="checkbox">
                        <Input className="form-check-input" type="checkbox" id="recurringDayOfWeekMonday" name="recurringDayOfWeek" value="monday" defaultChecked={this.state.departureSchedule.recurringDaysOfWeek && this.state.departureSchedule.recurringDaysOfWeek.includes('monday')} onChange={this.updateDepartureScheduleState}/>
                        <Label check className="form-check-label" htmlFor="recurringDayOfWeekMonday">Monday</Label>
                      </FormGroup>
                      <FormGroup check className="checkbox">
                        <Input className="form-check-input" type="checkbox" id="recurringDayOfWeekTuesday" name="recurringDayOfWeek" value="tuesday" defaultChecked={this.state.departureSchedule.recurringDaysOfWeek && this.state.departureSchedule.recurringDaysOfWeek.includes('tuesday')} onChange={this.updateDepartureScheduleState}/>
                        <Label check className="form-check-label" htmlFor="recurringDayOfWeekTuesday">Tuesday</Label>
                      </FormGroup>
                      <FormGroup check className="checkbox">
                        <Input className="form-check-input" type="checkbox" id="recurringDayOfWeekWednesday" name="recurringDayOfWeek" value="wednesday" defaultChecked={this.state.departureSchedule.recurringDaysOfWeek && this.state.departureSchedule.recurringDaysOfWeek.includes('wednesday')} onChange={this.updateDepartureScheduleState}/>
                        <Label check className="form-check-label" htmlFor="recurringDayOfWeekWednesday">Wednesday</Label>
                      </FormGroup>
                      <FormGroup check className="checkbox">
                        <Input className="form-check-input" type="checkbox" id="recurringDayOfWeekThursday" name="recurringDayOfWeek" value="thursday" defaultChecked={this.state.departureSchedule.recurringDaysOfWeek && this.state.departureSchedule.recurringDaysOfWeek.includes('thursday')} onChange={this.updateDepartureScheduleState}/>
                        <Label check className="form-check-label" htmlFor="recurringDayOfWeekThursday">Thursday</Label>
                      </FormGroup>
                      <FormGroup check className="checkbox">
                        <Input className="form-check-input" type="checkbox" id="recurringDayOfWeekFriday" name="recurringDayOfWeek" value="friday" defaultChecked={this.state.departureSchedule.recurringDaysOfWeek && this.state.departureSchedule.recurringDaysOfWeek.includes('friday')} onChange={this.updateDepartureScheduleState}/>
                        <Label check className="form-check-label" htmlFor="recurringDayOfWeekFriday">Friday</Label>
                      </FormGroup>
                      <FormGroup check className="checkbox">
                        <Input className="form-check-input" type="checkbox" id="recurringDayOfWeekSaturday" name="recurringDayOfWeek" value="saturday" defaultChecked={this.state.departureSchedule.recurringDaysOfWeek && this.state.departureSchedule.recurringDaysOfWeek.includes('saturday')} onChange={this.updateDepartureScheduleState}/>
                        <Label check className="form-check-label" htmlFor="recurringDayOfWeekSaturday">Saturday</Label>
                      </FormGroup>
  					<br/>
                    </Col>
  				</Row>
  				<Row>
  				  <Col xs="12">
                      <FormGroup>
                        <Label htmlFor="temperatureInC">Temperature</Label>
                        <Input type="select" name="temperatureInC" id="temperatureInC" value={temperatureInC} onChange={this.updateDepartureScheduleState}>
					      <OptionsTemperatureUnitFahrenheit show={temperatureUnit === 'fahrenheit'}/>
					      <OptionsTemperatureUnitCelsius show={temperatureUnit === 'celsius'}/>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Button 
  					id="saveDepartureSchedule"
					name="saveDepartureSchedule"
  					type="submit" 
  					size="sm" 
  					color="primary" 
					disabled={true} 
  					onClick={this.saveDepartureScheduleEvent}><i className="fa fa-dot-circle-o"></i> Save</Button>
		            <Button 
						type="submit" 
						size="sm" 
						color="danger" 
						onClick={this.deleteDepartureSchedule}><i className="fa fa-ban"></i> Delete</Button>
					<MessageSoonOnlyWithoutSubscription show={!isSubscriptionActive}/>
                </CardFooter>
              </Card>
			</IdleTimer>
            </Col>
          </Row>
        </div>
      )
    }
}

function MessageNoVehicles(props) {
	if (!props.show) {
		return null;
	}
	
  	return (
  		<small>No vehicles found in Tesla account. Please check your Tesla credentials in Settings.</small>
  	);
}

function MessageSoonOnlyWithoutSubscription(props) {
	if (!props.show) {
		return null;
	}
	
  	return (
  		<small>"Soon" is the only available departure type without a subscription.
		Please purchase a subscription to schedule future departures.
		Subscriptions are available in Settings.</small>
  	);
}

function OptionsTemperatureUnitFahrenheit(props) {
	if (!props.show) {
		return null;
	}
	
  	return (
		<React.Fragment>
          <option value="15.6">60F</option>
          <option value="16.2">61F</option>
          <option value="16.7">62F</option>
          <option value="17.2">63F</option>
          <option value="17.8">64F</option>
          <option value="18.3">65F</option>
          <option value="18.9">66F</option>
          <option value="19.4">67F</option>
          <option value="20.0">68F</option>
          <option value="20.6">69F</option>
          <option value="21.1">70F</option>
          <option value="21.7">71F</option>
          <option value="22.2">72F</option>
          <option value="22.8">73F</option>
          <option value="23.3">74F</option>
          <option value="23.9">75F</option>
          <option value="24.4">76F</option>
          <option value="25.0">77F</option>
          <option value="25.6">78F</option>
          <option value="26.1">79F</option>
          <option value="26.7">80F</option>
          <option value="27.2">81F</option>
          <option value="27.8">82F</option>
		</React.Fragment>
  	);
}

function OptionsTemperatureUnitCelsius(props) {
	if (!props.show) {
		return null;
	}
	
  	return (
		<React.Fragment>
          <option value="15.5">15.5C</option>
          <option value="16.0">16.0C</option>
          <option value="16.5">16.5C</option>
          <option value="17.0">17.0C</option>
          <option value="17.5">17.5C</option>
          <option value="18.0">18.0C</option>
          <option value="18.5">18.5C</option>
          <option value="19.0">19.0C</option>
          <option value="19.5">19.5C</option>
          <option value="20.0">20.0C</option>
          <option value="20.5">20.5C</option>
          <option value="21.0">21.0C</option>
          <option value="21.5">21.5C</option>
          <option value="22.0">22.0C</option>
          <option value="22.5">22.5C</option>
          <option value="23.0">23.0C</option>
          <option value="23.5">23.5C</option>
          <option value="24.0">24.0C</option>
          <option value="24.5">24.5C</option>
          <option value="25.0">25.0C</option>
          <option value="25.5">25.5C</option>
          <option value="26.0">26.0C</option>
          <option value="26.5">26.5C</option>
          <option value="27.0">27.0C</option>
          <option value="27.5">27.5C</option>
          <option value="28.0">28.0C</option>
		</React.Fragment>
  	);
}

function mapStateToProps(state, ownProps) {
	let departureSchedule = {
		type: null,
		onceTime: null,
		recurringDaysOfWeek: [],
		recurringHour: 0,
		recurringMinute: 0
	};
	
	const departureScheduleId = ownProps.match.params.departureScheduleId;
	
	if (departureScheduleId && state.departureSchedules.length > 0) {
		departureSchedule = Object.assign({}, state.departureSchedules.find(departureSchedule => departureSchedule.id === departureScheduleId));
	}
	
	return {
		departureSchedule: departureSchedule,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(departureScheduleActions, dispatch)
	}
}

Schedule.contextTypes = {
	authToken: PropTypes.string.isRequired,
	subscriptions: PropTypes.object.isRequired,
	departureSchedules: PropTypes.array.isRequired,
	teslaVehicles: PropTypes.array.isRequired,
	preferences: PropTypes.object.isRequired
}

Schedule.propTypes = {
	departureSchedule: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
};

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withRouter,
	withDepartureSchedules
)(Schedule);



// WEBPACK FOOTER //
// ./src/views/Schedule/Schedule.js